module.exports = __webpack_public_path__ + "img/TipperRoof_Overview-Spare_1.c4c01db9.jpg";